import { Box } from "@mui/material";
import { useState } from "react";
import { Navigate } from "react-router-dom";

// call page
import ProductManagementMenu from "../features/production/production-menu";
import PaperRollProduction from "../features/production/parentroll/Booking";
import WinderMachineProduction from "../features/production/winderprocess/WinderMachineProduction";
import ReelWeightment from "../features/production/reelweightment/ReelWeightment";
import ProductScanningPage from "../features/production/product_scanning/ProductScanningPage";
import SheeterConvertionProcess from "../features/production/sheetconvertion/ConvertionProcess";
import BundleLabel from "../features/production/bundle/BundlePunching";
import ReamLabel from "../features/production/reampunching/ReamPunching";

import PrintProductCodes from "../features/production/printcode/PrintProductCode";
import ProductionReports from "../features/production/mis/ProductionReport";

import ReamPalletLabel from "../features/production/reampallet/ReamPalletPunching";
import AddStorageLocationForFG from "../features/production/fg/AddStorageLocationForFG";
import TransferReelBasedOnSONumber from "../features/production/reeltransfer/ReelTransferProcess";
import ReportCenter from "../components/ReportCenter";
import WinderSummaryList from "../features/production/windermachineprocess/WinderSummary";
import AddStorageLocationForFGWarehouse from "../features/production/fgWarehouse/AddStorageLocationForFGWarehouse";
import ReverseStorageLocationForFGWarehouse from "../features/production/fgWarehouse/ReverseStorageLocationForFGWarehouse";
import WarehouseMasterDataReport from "../features/warehousenew/warehouse-data-report/WarehouseDataReport";
import RepulpWasteEntry from "../features/production/repulprocess/RepulpWasteEntry";
import RepulpWasteModule from "../features/production/repulprocess/RepulpWasteModule";
import RepulpWasteListIndex from "../features/production/repulpentry/RepulpWasteListIndex";
import ProductionSummary from "../features/production/reports/ProductionSummary";
import RepulpEntryReport from "../features/production/reports/RepulpEntryReport";
import StockStackingReport from "../features/production/reports/StockStackingReport";
import ProductionChat from "../features/chat/ProductionChat";
import JumboNowiseReport from "../features/warehousenew/warehouse-data-report/JumboNowiseReport";
import JumboNoTrackingReportWithAPI from "../features/warehousenew/warehouse-data-report/JumboNoTrackingReportWithAPI";

import { RemoveSharp } from "@mui/icons-material";
import RemarkWiseProductionReport from "../features/production/reports/RemarkWiseProductionReport";
import JumboWiseReport from "../features/production/reports/JumboWiseReport";
const ProductionManagement = () => {

    const [activePage, setActivePage] = useState('ViewMainPage');


    const SetActive = (page) => {
        setActivePage(page);
    }

    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');
    }
    const handleBackDashboard = () => {
        Navigate("/");
    }


    return (


        <Box position="relative">

            {activePage === "ViewMainPage" && (<ProductManagementMenu
                SetActive={SetActive} handleBackDashboard={handleBackDashboard}
            />

            )}

            {/* 1. Paper Machine Production Entry */}

            {/* {hasPermission(userPermissions,"Paper Machine Production", "Enabled") && activePage === "ViewPaperMachineEntryPage" && (
                <PaperRollProduction handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {activePage === "ViewPaperMachineEntryPage" && (
                <PaperRollProduction handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {/* Winder Reel Production Entry */}
            {activePage === "ViewWinderMachinePage" && (
                <WinderMachineProduction editParentRollID={''} handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {/* view Reel Weightment */}
            {activePage === "ViewReelWeightment" && (
                <ReelWeightment handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {/* QR Code Scanning */}
            {activePage === "ViewQRCodeScanning" && (
                <ProductScanningPage handleBack={handleBackWinderMachineEntry} />
            )}

            {/* Cutter Sheet Convertion Entry */}
            {activePage === "ViewCutterProductionEntryPage" && (
                <SheeterConvertionProcess handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ViewReamWeightment" && (
                <ReamLabel handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ViewBundleWeightment" && (
                <BundleLabel handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ViewReamPallet" && (
                <ReamPalletLabel handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {/* {activePage === "ViewInventoryLog" && (
                <InventoryLog handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {/* {activePage === "ViewDocumentSequence" && (
                <ViewProductionDocumentSequence handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {/* {activePage === "ViewQRCodeSettings" && (
                <ViewQRAndBarCodeSettings handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {activePage === "PrintQRCode" && (
                <PrintProductCodes handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ProductionReports" && (
                <ProductionReports handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "StoreFGINProduct" && (
                <AddStorageLocationForFG handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}


            {activePage === "StoreFGINProductWarehouse" && (
                <AddStorageLocationForFGWarehouse handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ReverseFGINProductWarehouse" && (
                <ReverseStorageLocationForFGWarehouse handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {/* {activePage === "ProductionDashbaord" && (
                <ProductionDashboard handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {activePage === "TransferReel" && (
                <TransferReelBasedOnSONumber handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "WinderProcess1" && (
                <WinderSummaryList handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ProductionMasterReport" && (
                <WarehouseMasterDataReport handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {activePage === "RepulpWasteListIndex" && (
                <RepulpWasteListIndex handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {activePage === "RepulpEntryReport" && (
                <RepulpEntryReport handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {activePage === "ProductionSummary" && (
                <ProductionSummary handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "StockStackingReport" && (
                <StockStackingReport handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

             {/* {activePage === "JumboNowiseReport" && (
                <JumboNowiseReport handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}
             {activePage === "JumboNoTrackingReportWithAPI" && (
                <JumboNoTrackingReportWithAPI handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {/* {activePage === "TransferReel" && (
                <ReportCenter />
            )} */}
            {activePage === "AIChat" && (
                <ProductionChat handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "RemarkWiseProductionReport" && (
                <RemarkWiseProductionReport handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

             {activePage === "JumboWiseReport" && (
                <JumboWiseReport handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}





        </Box>
    );
};
export default ProductionManagement;